// شاشة التحميل — شعار velorci (business operating platform)
// المونوغرام (المسار الفيكتور الرسمي) يُرسم بخط ثم يُعبّأ، وبعدها يظهر الاسم.
// SVG/CSS فقط — بدون أي مكتبة.

// حركة الدخول (رسم/تعبئة الشعار + ظهور الاسم والنقاط) تُعرض **مرة واحدة** لكل جلسة.
// إذا أُعيد تركيب المكوّن أثناء التحميل (re-mount) لا يُعاد الرسم من الصفر: نحسب
// الوقت المنقضي منذ أول ظهور ونزيح تأخير الحركات بمقداره، فتُكمل من مكانها أو تظهر
// جاهزة مباشرة — وتبقى النقاط الثلاث تنبض دائماً (infinite) كمؤشّر تحميل.
let introStartedAt = 0; // طابع زمني (ms) لأول مرة ظهرت فيها الشاشة خلال هذه الجلسة

export default function Spinner() {
  const teal = "#083A3F";
  const bg = "#E8FFFE";

  if (!introStartedAt) introStartedAt = Date.now();
  const elapsed = Math.max(0, (Date.now() - introStartedAt) / 1000); // ثوانٍ منذ أول ظهور
  // تأخير كل حركة بعد طرح الوقت المنقضي: قيمة سالبة كبيرة = الحركة انتهت وتُعرض بحالتها النهائية.
  const d = (base) => (base - elapsed).toFixed(3) + "s";
  return (
    <div style={{ position:"fixed", inset:0, background:bg, display:"flex", alignItems:"center", justifyContent:"center", zIndex:9999 }}>
      <div style={{ textAlign:"center", display:"flex", flexDirection:"column", alignItems:"center", gap:22 }}>
        {/* الأيقونة (المونوغرام الرسمي) — تُرسم بخط ثم تُعبّأ */}
        <svg className="vlc-mark" width="168" height="112" viewBox="0 0 146.975 97.986"
             aria-label="velorci" role="img">
          <path pathLength="100" fillRule="evenodd"
            d="M 32.66 40.83 L 40.83 32.66 C 57.16 48.99 73.49 65.32 89.82 81.65 C 97.98 73.49 122.48 48.99 130.64 40.83 L 106.15 16.33 L 81.65 40.83 L 89.82 48.99 L 107.95 30.85 L 116.12 39.02 L 97.98 57.16 L 89.82 65.32 L 89.05 64.56 L 88.29 63.79 L 87.52 63.03 L 86.75 62.26 L 85.99 61.50 L 85.22 60.73 L 84.46 59.97 L 83.69 59.20 L 82.93 58.43 L 82.16 57.67 L 81.65 57.16 L 40.82 16.33 C 32.66 24.50 24.50 32.66 16.33 40.83 C 32.66 57.16 48.99 73.49 65.32 89.82 L 57.16 97.99 C 38.10 78.93 19.05 59.88 0.00 40.83 C 13.61 27.22 27.22 13.61 40.83 0.00 L 73.49 32.66 L 106.15 0.00 C 119.76 13.61 133.37 27.22 146.98 40.83 C 133.37 54.44 103.43 84.38 89.82 97.99 C 70.76 78.93 51.71 59.88 32.66 40.83 Z" />
        </svg>

        {/* الاسم + السلوجن — الـ wordmark الرسمي (نفس خط اللوجو تماماً) */}
        <img className="vlc-name" src="/velorci-wordmark.png" alt="velorci — business operating platform" width="200" style={{ height:"auto", display:"block" }} />

        {/* مؤشر التحميل (نقاط نابضة) */}
        <div className="vlc-dots" style={{ display:"flex", gap:8, marginTop:6 }}>
          <span className="vlc-dot" />
          <span className="vlc-dot" />
          <span className="vlc-dot" />
        </div>
      </div>

      <style>{`
        .vlc-mark path {
          fill: ${teal};
          fill-opacity: 0;
          stroke: ${teal};
          stroke-width: 2.2;
          stroke-linejoin: round;
          stroke-linecap: round;
          stroke-dasharray: 100;
          stroke-dashoffset: 100;
          animation: vlcStroke 1.5s ease ${d(0)} forwards, vlcFill 0.5s ease ${d(1.35)} forwards;
        }
        @keyframes vlcStroke { to { stroke-dashoffset: 0; } }
        @keyframes vlcFill { from { fill-opacity: 0 } to { fill-opacity: 1 } }

        .vlc-name { opacity: 0; animation: vlcUp 0.55s ease ${d(1.75)} forwards; }
        .vlc-dots { opacity: 0; animation: vlcUp 0.55s ease ${d(2.15)} forwards; }
        @keyframes vlcUp { from { opacity: 0; transform: translateY(8px) } to { opacity: 1; transform: none } }

        .vlc-dot { width:8px; height:8px; border-radius:50%; background:${teal}; opacity:.35; animation: vlcDot 1.1s ease-in-out infinite; }
        .vlc-dot:nth-child(2){ animation-delay:.18s } .vlc-dot:nth-child(3){ animation-delay:.36s }
        @keyframes vlcDot { 0%,100%{ opacity:.25; transform:translateY(0) } 40%{ opacity:1; transform:translateY(-5px) } }

        @media (prefers-reduced-motion: reduce) {
          .vlc-mark path { fill-opacity: 1; stroke-dashoffset: 0; animation: none; }
          .vlc-name, .vlc-dots { opacity: 1; animation: none; }
          .vlc-dot { animation: vlcDot 1.1s ease-in-out infinite; }
        }
      `}</style>
    </div>
  );
}
